import { useQuery } from '@tanstack/react-query'

import { roomQueries, TRoomsSearchParams } from '@/entities/room'

type Props = {
  filters: TRoomsSearchParams
}

export const useRoomsCountQuery = ({ filters }: Props) => {
  const { data, isLoading } = useQuery({
    ...roomQueries.roomsCount(filters),
    enabled: false,
  })

  return {
    roomCount: data?.roomCount ?? null,
    isLoading,
  }
}
